import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=145cefd0&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=ts"
export * from "./Plan.vue?vue&type=script&lang=ts"
import style0 from "./Plan.vue?vue&type=style&index=0&id=145cefd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cefd0",
  null
  
)

export default component.exports
import {QCard,QImg,QItem,QItemSection,QAvatar,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QImg,QItem,QItemSection,QAvatar,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
